<template>
  <!-- Work Section-->
  <section class="pt-0 bg-gradient-to-r from-gray-50 to-gray-100">
    <div class="container mx-auto px-4 py-16">
      <div class="text-center mb-10">
        <h2 class="text-3xl font-bold text-black mb-2 text-[#B89666]">Enostavno in zanesljivo</h2>
        <p class="text-gray-600">
          V poplavi informacij je težko najti pravi ponudnika. Lexo vam omogoča, da na eni strani najdete in rezervirate storitve za vaše potrebe. Brez registracije in nepotrebne birokracije.
        </p>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-4 gap-3 mb-10">
        <div class="flex flex-col items-center text-center">
          <img src="/images/icons/clipboard-text-search-outline.svg" alt="Poišči strokovnjaka" title="Poišči strokovnjaka" class="h-12 w-12 mb-3" />
          <h6 class="text-black mb-2 font-semibold">1. Poišči strokovnjaka</h6>
          <p class="text-gray-600">V iskalniku izberi področje kjer potrebuješ pomoč.</p>
        </div>
        <div class="flex flex-col items-center text-center">
          <img src="/images/icons/account-search.svg" alt="Preveri profil" title="Preveri profil" class="h-12 w-12 mb-3" />
          <h6 class="text-black mb-2 font-semibold">2. Preveri profil</h6>
          <p class="text-gray-600">Oglej si izkušnje, področja dela in ocene uporabnikov.</p>
        </div>
        <div class="flex flex-col items-center text-center">
          <img src="/images/icons/human-greeting-proximity.svg" alt="Stopi v stik" title="Stopi v stik" class="h-12 w-12 mb-3" />
          <h6 class="text-black mb-2 font-semibold">3. Stopi v stik</h6>
          <p class="text-gray-600">Pošlji sporočilo ali se dogovori za termin – hitro in varno.</p>
        </div>
        <div class="flex flex-col items-center text-center">
          <img src="/images/icons/archive-check-outline.svg" alt="Reši zadevo" title="Reši zadevo" class="h-12 w-12 mb-3" />
          <h6 class="text-black mb-2 font-semibold">4. Reši zadevo</h6>
          <p class="text-gray-600">Prejmi nasvet, dokument ali zastopanje – brez nepotrebnih zapletov.</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
</script> 